/**
 * Registry of built-in app themes.
 *
 * Each built-in theme lives in its own subdirectory (./terminal, future
 * ./solarized, etc.) and exports a TERMINAL_THEME-shaped object. This file
 * just collects them so the ThemeCustomizerContext has a single import.
 *
 * Why built-in rather than seeded in Firestore:
 *  - Version-controlled: the palette evolves alongside its companion SCSS.
 *  - Can't be accidentally deleted from the customizer UI.
 *  - Always available, including fresh Firebase projects with no theme docs.
 */

import { TERMINAL_THEME, BuiltInTheme } from './terminal';
import { GRAPHITE_THEME, BLOSSOM_THEME, ONYX_THEME } from './graphite';

export type { BuiltInTheme };

/** Ordered list of all built-in themes. Order drives the switcher UI. */
export const BUILT_IN_THEMES: BuiltInTheme[] = [
  TERMINAL_THEME,
  GRAPHITE_THEME,
  BLOSSOM_THEME,
  ONYX_THEME,
];

/** Convenience helper: is this ID a built-in theme? */
export function isBuiltInThemeId(id: string | null | undefined): boolean {
  if (!id) return false;
  return BUILT_IN_THEMES.some((t) => t.id === id);
}

/** Look up a built-in theme by ID, or null. */
export function findBuiltInTheme(id: string | null | undefined): BuiltInTheme | null {
  if (!id) return null;
  return BUILT_IN_THEMES.find((t) => t.id === id) ?? null;
}
